import { render, staticRenderFns } from "./Theme3Contact.vue?vue&type=template&id=b335f2f0&scoped=true&"
import script from "./Theme3Contact.vue?vue&type=script&lang=js&"
export * from "./Theme3Contact.vue?vue&type=script&lang=js&"
import style0 from "./Theme3Contact.vue?vue&type=style&index=0&id=b335f2f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b335f2f0",
  null
  
)

export default component.exports